// extracted by mini-css-extract-plugin
export default {"events":"EventSchedule_events__XP3M5","notesMonth":"EventSchedule_notesMonth__bmAL1","notesMonthSection":"EventSchedule_notesMonthSection__frfd7"};